import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const PurchaseInstructions = () => {
    const instructions = [
        {
            step: "1",
            text: "Place your order through our online shop.",
        },
        {
            step: "2",
            text: "You will receive a confirmation email with the pick up address.",
        },
        {
            step: "3",
            text: "Follow us on social media to join our foodie community.",
        },
    ];
    return (_jsxs("div", { className: "max-w-lg pt-10 pb-12 mx-auto ", children: [_jsx("h2", { className: "text-4xl font-bold text-center text-gray-100 mb-7 poiret-one", children: "Purchase Instructions" }), _jsx("div", { className: "px-4 space-y-6 text-left md:px-0", children: instructions.map(({ step, text }) => (_jsxs("div", { className: "flex flex-row text-gray-100 transition-transform duration-200 group hover:transform hover:translate-x-2", children: [_jsxs("span", { className: "flex-shrink-0 w-6 font-medium text-green-400", children: [step, "."] }), _jsx("p", { className: "flex-1 ml-3", children: text })] }, step))) })] }));
};
export default PurchaseInstructions;
